import { Chip, makeStyles } from '@material-ui/core';
import { ShoppingBasketRounded, SpaRounded } from '@material-ui/icons';

import { QuoteItem } from '../../types/quote.type';

const TYPE_STYLES = {
  product: { color: '#2e7d32', label: 'Produit', Icon: SpaRounded },
  basket: { color: '#1976d2', label: 'Panier', Icon: ShoppingBasketRounded },
} as const;

const useStyles = makeStyles({
  chip: ({ color }: { color: string }) => ({
    backgroundColor: color,
    color: '#fff',
    borderRadius: 4,
    '& .MuiChip-icon': { color: '#fff' },
  }),
});

type Props = { type: QuoteItem['type'] };

export function QuoteItemTypeChip({ type }: Props) {
  const style = TYPE_STYLES[type];
  const classes = useStyles({ color: style.color });
  const Icon = style.Icon;
  return <Chip className={classes.chip} icon={<Icon />} label={style.label} size="small" />;
}
